import React from "react";
import {Link} from "react-router-dom";
import ChevronUp from "../../icons/chevron-up";
import ChevronDown from "../../icons/chevron-down";

interface SidebarItem {
    title: string;
    icon: string;
    items?: SidebarItem[];
    url?: string;
}

interface SidebarItemWithUrl extends SidebarItem {
    url: string;
}

interface ExpandableSidebarItem extends SidebarItem {
    items: SidebarItem[];
}

const sidebarItems: Array<ExpandableSidebarItem | SidebarItemWithUrl> = [
    {
        title: "Cooking",
        icon: "book",
        items: [
            {
                title: "All Recipes",
                icon: "book",
                url: "/dashboard/cooking/recipe"
            },
            {
                title: "All Tools",
                icon: "book",
                url: "/dashboard/cooking/tool"
            },
            {
                title: "All Ingredients",
                icon: "book",
                url: "/dashboard/cooking/ingredient"
            },
            {
                title: "All Cuisine Types",
                icon: "book",
                url: "/dashboard/cooking/cuisineType"
            },
            {
                title: "Stats",
                icon: "chart-bar",
                url: "/dashboard/cooking/recipe/stats"
            }
        ]
    }, {
        title: "Note",
        icon: "book",
        items: [
            {
                title: "All Notes",
                icon: "book",
                url: "/dashboard/note/note"
            },
            {
                title: "All Tags",
                icon: "book",
                url: "/dashboard/note/tag"
            }
        ]
    }
];

function SidebarListItem({item}: { item: ExpandableSidebarItem }) {
    const [expanded, setExpanded] = React.useState(false);

    // Recursively
    return (<>
            <SidebarItemLabel item={item} onClick={() => setExpanded(!expanded)} expanded={expanded}/>
            <ul className={expanded ? "" : "collapsed"} aria-expanded={expanded}>
                {item.items.map((item, index) => (
                    <li key={index} className="item">
                        <SidebarItem item={item}/>
                    </li>
                ))}
            </ul>
        </>
    );
}

function SidebarItem({item}: { item: SidebarItem }) {
    if (item.items) {
        return (
            <li className="item">
                <SidebarListItem item={item as ExpandableSidebarItem}/>
            </li>
        );
    } else {
        return (
            <li className="item">
                <Link to={item.url!}>
                    <SidebarItemLabel item={item}/>
                </Link>
            </li>
        );
    }
}

function SidebarItemLabel({item, onClick, expanded}: { item: SidebarItem, onClick?: () => void, expanded?: boolean }) {
    return (
        <div className="label" onClick={onClick}>
            <div className="name">
                {item.title}
            </div>
            {expanded !== undefined && (expanded ? <ChevronUp/> : <ChevronDown/>)}
        </div>
    );
}

export default function DashboardSidebar() {
    return (
        <aside className="dashboard-sidebar">
            <nav>
                <ul>
                    {sidebarItems.map((item) => {
                        return (<SidebarItem item={item as SidebarItemWithUrl} key={item.title}/>);
                    })}
                </ul>
            </nav>
        </aside>
    );
}